import wNumb from 'wnumb';

const moneyFormat = wNumb({
	thousand : '.'
});

export default moneyFormat;